export default function RenovationCTA() {
  return (
    <section id="contact" className="py-20 bg-gray-900">
      <div className="max-w-4xl mx-auto px-6 lg:px-8 text-center">
        <div className="bg-gradient-to-br from-emerald-900/40 to-teal-900/40 border border-emerald-500/20 rounded-3xl p-12">
          <div className="w-14 h-14 flex items-center justify-center bg-emerald-500/20 rounded-2xl mx-auto mb-6">
            <i className="ri-home-gear-line text-emerald-400 text-2xl"></i>
          </div>
          <h2 className="text-2xl md:text-3xl font-black text-white mb-4">
            Votre projet de rénovation<br />
            <span className="text-emerald-400">commence ici</span>
          </h2>
          <p className="text-gray-400 text-base mb-8 max-w-xl mx-auto">
            Contactez CasaReNovaPlus pour un devis gratuit et sans engagement. Notre équipe se déplace à Neuenegg et dans toute la Suisse romande.
          </p>
          <div className="flex flex-wrap justify-center gap-4 mb-8">
            <a
              href="tel:+41764803188"
              className="inline-flex items-center gap-2 bg-emerald-500 hover:bg-emerald-600 text-white font-bold px-8 py-3.5 rounded-xl transition-colors whitespace-nowrap cursor-pointer"
            >
              <i className="ri-phone-fill"></i>
              Filipe: +41 76 480 31 88
            </a>
            <a
              href="tel:+41765654203"
              className="inline-flex items-center gap-2 bg-teal-600 hover:bg-teal-700 text-white font-bold px-8 py-3.5 rounded-xl transition-colors whitespace-nowrap cursor-pointer"
            >
              <i className="ri-phone-fill"></i>
              Francisco: +41 76 565 42 03
            </a>
            <a
              href="mailto:info@casarenovaplus.ch"
              className="inline-flex items-center gap-2 bg-white/10 hover:bg-white/20 border border-white/20 text-white font-semibold px-8 py-3.5 rounded-xl transition-colors whitespace-nowrap cursor-pointer"
            >
              <i className="ri-mail-line"></i>
              info@casarenovaplus.ch
            </a>
          </div>
          <p className="text-gray-500 text-xs">
            Austrasse 95 · 3176 Neuenegg · Suisse · Lun–Ven 8h–18h · Urgences 24/7
          </p>
        </div>
      </div>
    </section>
  );
}
